export const ActivityCategories = {
	TOOL: 'Tool',
	MEMORY: 'Memory',
	TRIGGER: 'Trigger',
	AGENT: 'Agent',
	AGENT_SERVICE: 'AgentService',
	DOCUMENTATION: 'Documentation',
	ERROR_HANDLING: 'ErrorHandling',
} as const;

export const ActivityTypes = {
	AGENT: 'AiAgent.Prompt',
	BLOCK: 'Block',
	NOTE: 'Note',
	SECTION: 'Section',
	ON_ERROR: 'OnError',
	LOOP: 'Loop',
	BLOCK_TOOL: 'Agent.Tool.Block',
	AGENT_PROGRESS_SINK: 'Conversation.AgentProgressSink',
	GROUP_TOOL: 'Agent.Tool.Group',
} as const;
